'use client';

import './style.sass';

import React from 'react';

import {
    listDescription,
    listPath,
    listProcess,
    listResults,
    listRules,
    listStatistic,
    listTarget,
    listTeam,
    listText,
    listTextMetrics,
    listTitle,
} from './constants';

import FullWrapper from '../../cases/reusable-components/layouts-components__common-cases/full-wrapper';
import ResultsBlock from '../../cases/reusable-components/new-medved__components/results-block';
import RulesBlock from '../../cases/reusable-components/new-medved__components/rules-block';
import SemanticBlock from '../../cases/reusable-components/new-medved__components/semantic-block';
import StatisticBlock from '../../cases/reusable-components/new-medved__components/statistic-block';
import TextBlock from '../../cases/reusable-components/new-medved__components/text-block';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';
import TitleCase from '../../case-components/title-case';
import TargetCase from '../../case-components/target-case';
import DescriptionCase from '../../case-components/description-case';
import ProcessCase from '../../case-components/process-case';
import TeamCase from '../../case-components/team-case';

const Medved = () => {
    return (
        <section>
            <TitleCase
                img="/images/pic/medved/medvedBanner.jpg"
                listPath={listPath}
                listTitle={listTitle}
                caseName="medved"
            />
            <TargetCase listTarget={listTarget} />
            <DescriptionCase listDescription={listDescription} customClass="default" />
            <ProcessCase listProcess={listProcess} />
            <SemanticBlock />
            <TextBlock listText={listText} />
            <RulesBlock listRules={listRules} />
            <TextBlock listText={listTextMetrics} />
            <StatisticBlock listStatistic={listStatistic} />
            <ResultsBlock listResults={listResults} />
            <TeamCase listTeam={listTeam} />
            <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                <FullWrapper>
                    <OfferButton linkText="Нанять команду" />
                </FullWrapper>
            </ScrollAnimation>
        </section>
    );
};

export default Medved;
